import PropTypes from 'prop-types';
import styled from 'styled-components';

const PageContainer = ({ children }) => {
  return <Container>{children}</Container>;
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageContainer;

const Container = styled.div`
  margin: 0 4rem;

  @media print {
    margin: 0 8mm;
  }
`;

export { Container };
